import React from "react";
import GrComponentFactory from "../gr_component_factory";
import ShapeIcon from "../shape_icon";
import { ICON_SIZES, ICON_SHAPES } from "../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "GroupIcon",

  propTypes: {
    group: React.PropTypes.shape({
      name: React.PropTypes.string.isRequired,
      iconUrl: React.PropTypes.string.isRequired,
      url: React.PropTypes.string.isRequired,
    }).isRequired,
    includeLink: React.PropTypes.bool,
    size: React.PropTypes.oneOf([ICON_SIZES.SMALL, ICON_SIZES.MEDIUM, ICON_SIZES.LARGE]),
  },

  getDefaultProps() {
    return {
      includeLink: false,
      size: ICON_SIZES.SMALL,
    };
  },

  render() {
    const group = this.props.group;
    return <ShapeIcon imageUrl={group.iconUrl}
                      imageAlt={group.name}
                      linkUrl={group.url}
                      shape={ICON_SHAPES.ROUND_SQUARE}
                      size={this.props.size}
                      includeLink={this.props.includeLink} />;
  },

});
